






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Warning extends Vue {
  @Prop({ default: 'div' })
  readonly tag: string
}
